<template>
    <div class="p-5" v-if="donationData">
        <div class="d-flex justify-content-between align-items-center mb-5">
            <div class="d-flex justify-content-start">
                <div class="c-title">
                    Donation:
                    <span v-text="formatCurrency(donationData.donation_amount)"></span>
                </div>
                <div class="c-title ml-5" style="cursor: pointer" @click="() => {
                    $router.push({ name: 'SupporterView', params: { email: donationData.email } });
                }">
                    Supporter:
                    <span class="supporter-name">
                        {{ donationData.first_name + ' ' + donationData.last_name }}
                        <a href="javascript:;" class="ml-2">
                            <img
                                src="~@/assets/images/open-link.svg"
                            />
                        </a>
                    </span>
                </div>
            </div>
            <div class="d-flex align-items-end">
                <button
                    @click="sendReceipt"
                    class="btn c-btn-receipt align-self-end"
                >
                    <img src="@/assets/images/supporters/receipt-white.svg" width="30" alt="Export" />
                </button>
                <button
                    @click="goBack"
                    class="btn c-btn-add align-self-end ml-2"
                >
                    Back
                </button>
            </div>
        </div>

        <div class="">
            <div class="row mt-2 pl-2 pr-2">
                <div class="col-md-6 col-sm-12">
                    <TextField
                        v-model="campaignTitle"
                        name="campaign_title"
                        label="Campaign"
                        disabled
                    >
                        <template #append-icon>
                            <a href="javascript:;" @click="() => {
                                $router.push({ name: 'CampaignsView', params: { id: donationData.campaign_id } });
                            }">
                                <img
                                    src="~@/assets/images/open-link.svg"
                                />
                            </a>
                        </template>
                    </TextField>
                    <TextField
                        v-model="designationName"
                        name="designation_name"
                        label="Designation"
                        disabled
                    />
                </div>
                <div class="col-md-6 col-sm-12">
                    <TextField
                        v-model="date"
                        name="donation_date"
                        label="Date"
                        type="text"
                        disabled
                    />

                    <TextField
                        v-model="frequency"
                        name="frequency"
                        label="Frequency"
                        disabled
                    />
                </div>
            </div>
            <div class="row mt-2 pl-2 pr-2">
                <div class="col-md-6 col-sm-12">
                    <div class="c-label">Payment and Fees</div>
                    <TextField
                        v-model="donationAmount"
                        name="donation_amount"
                        label="Donation amount"
                        disabled
                    />

                    <TextField
                        v-model="capturedAmount"
                        name="captured_amount"
                        label="Captured amount"
                        disabled
                    />

                    <TextField
                        v-model="processingFee"
                        name="processing_fee"
                        label="Processing fee"
                        disabled
                    />

                    <TextField
                        v-model="platformFee"
                        name="platform_fee"
                        label="Platform fee"
                        disabled
                    />

                    <TextField
                        v-model="payoutAmount"
                        name="payout_amount"
                        label="Payout amount"
                        disabled
                    />
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="c-label">Processor</div>
                    <TextField
                        v-model="processor"
                        name="processor"
                        label="Processor"
                        disabled
                    />

                    <TextField
                        v-model="transactionId"
                        name="transaction_id"
                        label="Transaction ID"
                        disabled
                    />

                    <TextField
                        v-model="creditCardBrand"
                        name="credit_card_brand"
                        label="Credit card brand"
                        disabled
                    />

                    <TextField
                        v-model="creditCard"
                        name="credit_card"
                        label="Credit card"
                        disabled
                    />
                </div>
            </div>
            <div class="row mt-2 pl-2 pr-2" v-if="donationData.subscription">
                <div class="col-md-6 col-sm-12">
                    <div class="c-label">Recurring Payments</div>
                    <TextField
                        v-model="startedOn"
                        name="started_on"
                        label="Started on"
                        disabled
                    />
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="c-label">&nbsp;</div>
                    <div class="d-flex justify-content-between align-items-center">
                        <TextField
                            v-model="status"
                            name="status"
                            label="Status"
                            disabled
                            class-wrapper="w-100"
                        />
                        <div style="margin-top: -30px" v-if="status.toLowerCase() === 'active' && DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.DONATION_STOP_SUBSCRIPTION)">
                            <button
                                @click="stopSubscription"
                                class="btn c-btn-add align-self-end ml-2"
                            >
                                Stop
                            </button>
                        </div>
                    </div>

                    <TextField
                        v-model="totalDonated"
                        name="total_donated"
                        label="Total donated"
                        disabled
                    />

                    <TextField
                        v-model="totalPayout"
                        name="total_payout"
                        label="Total payout"
                        disabled
                    />
                </div>
                <div class="col-md-6 col-sm-12 installments">
                    <div class="d-flex installment-headers">
                        <div class="installment-header">
                            Installment
                        </div>
                        <div class="ml-5 installment-header">
                            Date
                        </div>
                        <div class="ml-5">&nbsp;</div>
                    </div>
                    <div class="d-flex installment-items" v-for="(payment, index) in donationData.subscription.payments" v-bind:key="index">
                        <div class="installment-item">
                            {{ index + 1 }}
                        </div>
                        <div class="ml-5 installment-item">
                            {{ formatDate(payment.date) }}
                        </div>
                        <div class="ml-5 installment-item">
                            <a href="javascript:;" v-if="!payment.is_self" @click="goToSelfDonation(payment.donation_id)">
                                <img
                                    src="~@/assets/images/open-link.svg"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-2 pl-2 pr-2" v-if="donationData.questions.length">
                <div class="col-md-6 col-sm-12">
                    <div class="c-label">Questions</div>
                    <div v-bind:key="index" v-for="(question, index) in donationData.questions">
                        <TextareaField
                            v-if="question.answer.length > 110"
                            v-model="question.answer"
                            name="question"
                            :label="question.question"
                            disabled
                            class="mb-3"
                        />

                        <TextField
                            v-else
                            v-model="question.answer"
                            name="question"
                            :label="question.question"
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div class="row mt-2 pl-2 pr-2" v-if="source || widget || distribution">
                <div class="col-md-6 col-sm-12">
                    <div class="c-label">Source</div>
                    <TextField
                        v-if="source"
                        v-model="source"
                        name="source"
                        label="Source"
                        disabled
                    />

                    <TextField
                        v-if="widget"
                        v-model="widget"
                        name="widget"
                        label="Widget"
                        disabled
                    >
                        <template #append-icon>
                            <a href="javascript:;" @click="() => {
                                openWidgetModal(donationData.widget_id);
                            }">
                                <img
                                    src="~@/assets/images/open-link.svg"
                                />
                            </a>
                        </template>
                    </TextField>

                    <TextField
                        v-if="distribution"
                        v-model="distribution"
                        name="distribution"
                        label="Distribution"
                        disabled
                    >
                        <template #append-icon>
                            <a href="javascript:;" @click="() => {
                                openDistributionModal(donationData.distribution_id);
                            }">
                                <img
                                    src="~@/assets/images/open-link.svg"
                                />
                            </a>
                        </template>
                    </TextField>
                </div>
            </div>

            <div class="row mt-2 pl-2 pr-2" v-if="dedication || comment">
                <div class="col-md-6 col-sm-12">
                    <div class="c-label">Other Info</div>
                    <div v-if="dedication">
                        <TextareaField
                            v-if="dedication.length > 110"
                            v-model="dedication"
                            name="dedication"
                            label="Dedication"
                            disabled
                            class="mb-4"
                        />
                        <TextField
                            v-else
                            v-model="dedication"
                            name="dedication"
                            label="Dedication"
                            disabled
                        />
                    </div>

                    <div v-if="comment">
                        <TextareaField
                            v-if="comment.length > 110"
                            v-model="comment"
                            name="comment"
                            label="Comment"
                            disabled
                            class="mb-4"
                        />

                        <TextField
                            v-else
                            v-model="comment"
                            name="comment"
                            label="Comment"
                            disabled
                            />
                    </div>
                </div>
            </div>
        </div>

        <modal-view-distribution
            v-if="isShowDistributionModal"
            :data="distributionItemData"
            @close="isShowDistributionModal = false"
        />

        <ModalWidgetDonation
            v-if="isShowDonationModal"
            :is-read-only="true"
            :data="widgetItemData"
            :campaign-title="campaignTitle"
            :designation-name="designationName"
            @success="() => {
                isShowDonationModal = false;
            }"
            @close="isShowDonationModal = false"
        />

        <ModalWidgetSupporter
            v-if="isShowSupporterModal"
            :is-read-only="true"
            :data="widgetItemData"
            :campaign-title="campaignTitle"
            @success="() => {
                isShowSupporterModal = false;
            }"
            @close="isShowSupporterModal = false"
        />

        <ModalWidgetGoalMeter
            v-if="isShowGoalMeterModal"
            :data="widgetItemData"
            :campaign-title="campaignTitle"
            @success="() => {
                isShowGoalMeterModal = false;
            }"
            @close="isShowGoalMeterModal = false"
        />
    </div>
</template>

<script>
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import TextField from "@/commons/FormElements/TextField.vue";
import ModalWidgetSupporter
    from "@/components/widgets/components/ModalWidgetSupporter.vue";
import ModalWidgetGoalMeter
    from "@/components/widgets/components/ModalWidgetGoalMeter.vue";
import ModalWidgetDonation
    from "@/components/widgets/components/ModalWidgetDonation.vue";
import TextareaField from "@/commons/FormElements/TextareaField.vue";
import ModalViewDistribution
    from "@/components/campaigns/components/ModalViewDistribution.vue";
import DibbleJS from "@/dibble";
import Authorizations from "@/utils/authorizations";
export default {
    name: 'DonationView',
    computed: {
        Authorizations() {
            return Authorizations
        }
    },
    components: {
        ModalViewDistribution,
        TextareaField,
        ModalWidgetDonation, ModalWidgetGoalMeter, ModalWidgetSupporter,
        TextField,
    },
    data() {
        return {
            DibbleJS,
            donationId: '',
            donationData: null,

            isShowDonationModal: false,
            isShowSupporterModal: false,
            isShowGoalMeterModal: false,
            widgetItemData: null,
            isShowDistributionModal: false,
            distributionItemData: null,
            campaignTitle: '',
            designationName: '',
            date: '',
            frequency: '',
            donationAmount: '',
            capturedAmount: '',
            processingFee: '',
            platformFee: '',
            payoutAmount: '',
            processor: '',
            transactionId: '',
            creditCardBrand: '',
            creditCard: '',
            startedOn: '',
            status: '',
            totalDonated: '',
            totalPayout: '',
            widget: '',
            distribution: '',
            dedication: '',
            comment: '',
            source: ''
        };
    },
    watch: {
        donationData(val) {
            if (val) {
                this.campaignTitle = val.campaign_title || '';
                this.designationName = val.designation_name || '';
                this.date = this.formatDate(val.date) || '';
                this.frequency = val.frequency || '';
                this.donationAmount = this.formatCurrency(val.donation_amount) || '$0.00';
                this.capturedAmount = this.formatCurrency(val.captured_amount) || '$0.00';
                this.processingFee = this.formatCurrency(val.processing_fee) || '$0.00';
                this.platformFee = this.formatCurrency(val.platform_fee) || '$0.00';
                this.payoutAmount = this.formatCurrency( val.payout_amount) || '$0.00';
                this.processor = val.processor || '';
                this.transactionId = val.transaction_id || '';
                this.creditCardBrand = val.card_brand || '';
                this.creditCard = val.card_number || '';

                if (val.subscription) {
                    this.startedOn = this.formatDate(val?.subscription?.started_on) || '';
                    this.status = val?.subscription?.status || '';
                    this.totalDonated = this.formatCurrency( val?.subscription?.total_donated) || '$0.00';
                    this.totalPayout = this.formatCurrency( val?.subscription?.total_payout) || '$0.00';
                }

                this.widget = val.widget_name || '';
                this.distribution = val.distribution_title || '';
                this.dedication = val.dedication || '';
                this.comment = val.comment || '';
                this.source = val.source || '';
            }
        }
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'DonationsList' });
        },
        getData() {
            DibbleJs.showLoader();
            const params = {
                '#request': DibbleApi.api.donationGet,
                donation_id: this.donationId,
            };

            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.donationData = response;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        goToSelfDonation(id) {
            window.location.href = `/donation/view/${id}`;
        },
        formatNumber(number) {
            return new Intl.NumberFormat('en-US').format(number);
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
        },
        formatDate(date) {
            return this.$moment(date).format('MM/DD/YYYY HH:mm');
        },
        openWidgetEditModal() {
            switch (this.widgetItemData.type) {
                case 1:
                    this.isShowDonationModal = true;
                    break;
                case 2:
                    this.isShowSupporterModal = true;
                    break;
                case 3:
                    this.isShowGoalMeterModal = true;
                    break;
            }
        },
        getWidgetData(widget_id) {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.widgetGet,
                widget_id: widget_id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.widgetItemData = response;
                    this.openWidgetEditModal()
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        openWidgetModal(widget_id) {
            this.getWidgetData(widget_id)
        },
        getDistributionData(distribution_id) {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getDistribution,
                distribution_id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.distributionItemData = response;
                    this.isShowDistributionModal = true;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        openDistributionModal(distribution_id) {
            this.getDistributionData(distribution_id)
        },
        sendReceipt() {
            DibbleJS.confirmBox('Resend the receipt to the supporter?', () => {
                DibbleJS.showLoader()
                DibbleJS.callApiRequest({
                    '#request': DibbleApi.api.donationResendReceipt,
                    donation_id: this.donationId,
                }, (response) => {
                    DibbleJS.hideLoader();
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage(response.message)
                    } else {
                        DibbleJS.toastErrorMessage(response.message)
                    }
                }, this._onLoadBoatTypeFailed)
            })
        },
        stopSubscription() {
            DibbleJS.confirmBox('Are you sure want to stop this subscription?', () => {
                DibbleJS.showLoader()
                DibbleJS.callApiRequest({
                    '#request': DibbleApi.api.donationStopTilledSubscription,
                    subscription_id: this.donationData.subscription.subscription_id,
                }, (response) => {
                    DibbleJS.hideLoader();
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage(response.message)
                        this.getData()
                    } else {
                        DibbleJS.toastErrorMessage(response.message)
                    }
                }, this._onLoadBoatTypeFailed)
            })
        }
    },
    created() {
        this.donationId = this.$route.params.id;
        if (!this.donationId) {
            this.$router.push({ name: 'DonationsList' });
            DibbleJs.toastErrorMessage('Invalid email');
        } else {
            this.getData();
        }
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.c-archive-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}
.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-btn-add, .c-btn-receipt {
    color: #fff;
    width: 120px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 20px;
    font-weight: bold;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-btn-receipt {
    width: 70px;
}
.c-thead {
    th {
        color: #41B8DC;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;

        &.h-date {
            width: 10%;
        }
        &.h-phone {
            width: 10%;
        }
        &.h-email {
            width: 20%;
        }
        &.h-donation {
            width: 15%;
            text-align: right;
        }
        &.h-amount {
            width: 15%;
            text-align: right;
        }
        &.h-action {
            width: 25%;
        }
    }
}
.filter-date, .donation-filter {
    width: 340px;
    background-color: #e1e7e9;
    padding: 5px 16px 8px 16px;
    border-radius: 12px;
    position: relative;
    height: 59px;
    cursor: pointer;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    @media (max-width: 1750px) {
        width: auto;
    }

}
.donation-filter {
    width: 310px;
    height: 45px;

    /* Fix width on smaller screen*/
    @media (max-width: 1750px) {
        width: auto;
    }
}
</style>
<style lang="scss">
.filter-date {
    .form-control {
        background: none;

        div {
            input {
                background: none;
                border: none;
            }
        }

        .vdp-datepicker__clear-button {
            position: absolute;
            right: 1px;
            bottom: 10px;
        }
    }
}
.donation-filter {
    .multiselect__tags {
        background: transparent;
    }

    .multiselect__input, .multiselect__single {
        background: transparent;
        border: none;
        padding-top: 5px;
        color: #969fa2;
    }

    .multiselect__select {
        right: 3px;
        top: 9px;
        &:before {
            display: none
        }
    }
}

.checkbox-label {
    display: block;
}

.test {
    position: absolute;
    right: 1vw;
    width: 18px;
    height: 18px;
}
.clear-filter-button {
    font-size: 20px; color: #40b8dc;
}
.c-label {
    font-size: 20px;
    line-height: 24px;
    color: #555E67;
    margin-top: 33px;
    margin-bottom: 33px;
}
.installment-headers {
    border-bottom: 1px solid #DEE6EA;
    padding-bottom: 10px;
}
.installment-header {
    color: #41B8DC;
    font-weight: 600;
    font-size: 20px;
    width: 200px;
}
.installment-items {
    border-bottom: 1px solid #DEE6EA;
}
.installment-item {
    font-size: 16px;
    width: 200px;
    color: #555E67;
    padding-top: 10px;
    padding-bottom: 10px;
}
.supporter-name {
    color: #41B8DC;
}

@media only screen and (min-width: 768px) {
    .installments {
        margin-top: -180px;
    }
}
</style>
